export default abstract class CheckFeature {
  constructor () {}
  abstract hasFeature (): boolean
  abstract teamHasFeature (teamId: string): boolean
  abstract updateTeamFeature (teamId: string, enabled: boolean): void

  // If this is set to true, it is a feature that can only be enabled and disabled for everybody at the same time
  abstract isGlobalFeature (): boolean
}
